import { ALL_POSTERS } from "@/lib/constants";

// A repeating array so the wall is dense across large screens.
const WALL = [...ALL_POSTERS, ...ALL_POSTERS, ...ALL_POSTERS];

export default function PosterBackground() {
  return (
    <div className="fixed inset-0 -z-10 overflow-hidden pointer-events-none bg-background" aria-hidden="true">
      <div className="absolute inset-0 grid grid-cols-3 sm:grid-cols-4 lg:grid-cols-6 gap-1 opacity-[0.09] -rotate-6 scale-125">
        {WALL.map((src, i) => (
          <div key={`${src}-${i}`} className="aspect-[3/4] overflow-hidden">
            <img src={src} alt="" loading="lazy" className="w-full h-full object-cover grayscale" />
          </div>
        ))}
      </div>
      {/* dark wash + vignette so foreground content stays readable */}
      <div className="absolute inset-0 bg-gradient-to-b from-background/85 via-background/80 to-background/95" />
      <div className="absolute inset-0" style={{ boxShadow: "inset 0 0 240px 80px #0B0C10" }} />
    </div>
  );
}
